import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditorModule as KendoEditorModule } from '@progress/kendo-angular-editor';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { EditorComponent } from '@app/pages/main/pages/quality/components/shared/editor/editor.component';
import { EditorDirectivesModule } from '@app/pages/main/pages/quality/components/shared/editor/directives/editor-directives.module';
import { InsertImageModalComponent } from '@app/pages/main/pages/quality/components/shared/editor/modals/insert-image-modal/insert-image-modal.component';
import { ModalModule } from '@app/shared/dialogs/modal/modal.module';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { ButtonGroupModule, ChipModule } from '@progress/kendo-angular-buttons';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { TiDragDropComponent } from '@tpt/common/inputs/drag-drop';
import { SpinnerModule } from '@app/shared/ui/simple-components/spinner/spinner.module';
import { ReactiveFormsModule } from '@angular/forms';
import { RichTextAutoSizeDirective } from '@tpt/common/inputs/rich-text';

@NgModule({
  declarations: [EditorComponent, InsertImageModalComponent],
  imports: [
    CommonModule,
    KendoEditorModule,
    ToolBarModule,
    EditorDirectivesModule,
    ModalModule,
    TextBoxModule,
    ButtonGroupModule,
    ChipModule,
    TiDragDropComponent,
    PipesModule,
    SpinnerModule,
    ReactiveFormsModule,
    RichTextAutoSizeDirective,
  ],
  exports: [EditorComponent],
})
export class EditorModule {}
